import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { SopoSelectListSettings } from 'src/app/sopo-popup/interfaces/select-list';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';


@Component({
    selector: 'app-sopo-select-button',
    templateUrl: './sopo-select-button.component.html',
    styleUrls: ['./sopo-select-button.component.scss'],
    standalone: false
})
export class SopoSelectButtonComponent<ListType> implements OnInit, OnChanges, OnDestroy {
    @Input() title: string;
    @Input() list: ListType[];
    @Input() selected: ListType;
    @Input() listObject: {value: ListType , text: string}[];
    @Input() listText: string;
    @Input() selectedText: string = '';
    @Input() isInClub: boolean = false;
    @Input() showIcon: boolean = true;
    @Input() disabled: boolean = false;
    @Input() hidden: boolean = false;
    @Input() zIndex: number;
    @Input() isAlignedLeft = false;
    @Input() normalFontWeight = false;
    @Input() redBackground = false;
    @Output() selectedChange = new EventEmitter<ListType>();
    selectedObjectText: string = '';

    private _sopoDialogRef: SopoDialogRef | undefined;

    constructor(
        private sopoPopupService: SopoPopupService,
    ) { }

    ngOnInit() {
        if (this.listObject !== undefined) {
            this.listObject.forEach(item => {if (item.value === this.selected) this.selectedObjectText = item.text});
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selected !== undefined && this.listObject !== undefined) {
            this.listObject.forEach(item => { if (item.value === this.selected) this.selectedObjectText = item.text;});
            if (typeof changes.selected.currentValue === 'string' && changes.selected.currentValue.toLowerCase() === 'custom') this.selectedObjectText = 'CUSTOM';
        }
    }

    async showList() {
        const sopoSelectListSettings: SopoSelectListSettings<ListType> = {
            zIndex: this.zIndex ? this.zIndex : null,
            closeButton: true,
            data: {
                title: this.title,
                list: this.list,
                listObject: this.listObject,
                listText: this.listText,
                selected: this.selected,
            },
        };
        if (this.isInClub || this.redBackground) sopoSelectListSettings.sCss = ['sopo-popup-red-background'];

        this._sopoDialogRef = this.sopoPopupService.promptForSelectList<ListType>('app', sopoSelectListSettings);
        if (this._sopoDialogRef === null) return;

        const selection = await firstValueFrom(this._sopoDialogRef.afterClosed);
        this._sopoDialogRef = undefined;
        if (selection === null || selection === undefined) return;

        this.selected = selection as ListType;
        if (this.listObject) this.listObject.forEach(item => {if (item.value === this.selected) this.selectedObjectText = item.text});
        this.selectedChange.emit(this.selected);
    }

    ngOnDestroy(): void {
        this._sopoDialogRef?.close();
    }
}
